export const errors = {
  e000: { pl: "OK", en: "OK" },
  e001: { pl: "powtórzony skan", en: "repeated scan" },
  e002: { pl: "z poza zakresu", en: "out of range" },
  e003: { pl: "niepoprawny kod", en: "wrong code" },
  e004: { pl: "SN poza kolejnością", en: "SN out of sequence" },
};
